import { combineReducers } from '@reduxjs/toolkit';
import { aggregatedStatsReducer } from './reducers/aggregated-stats-reducer';
import { chartsReducer } from './reducers/charts-reducer';
import type { IStatsState } from './interfaces';

export default combineReducers<IStatsState>({
  aggregatedStatsReducer,
  chartsReducer,
});
